import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Languages, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const NAMES = { en: "EN", de: "DE", fr: "FR", es: "ES", ja: "JA" };

export const AdminTranslations = () => {
  const [s, setS] = useState(null);
  const load = () => api.get("/admin/translations/status").then((r) => setS(r.data));
  useEffect(() => {
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, []);
  const start = async () => {
    try {
      await api.post("/admin/translations/prewarm");
      toast.success("Aggiornamento traduzioni avviato");
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  if (!s) return null;
  return (
    <div className="mt-6 flex flex-wrap items-center gap-3 rounded-2xl border border-black/10 bg-white p-4 text-sm" data-testid="admin-translations">
      <Languages className="h-5 w-5 text-cyan-700" />
      <span className="font-semibold">Traduzioni pronte:</span>
      {Object.entries(NAMES).map(([k, v]) => <span key={k} className="rounded bg-black/5 px-2 font-mono text-xs" data-testid={`tr-count-${k}`}>{v} {s.counts[k]}</span>)}
      <span className="text-stone-500" data-testid="tr-status">{s.running ? `In corso (${s.done}/${s.total} lingue)` : "Nuovi prodotti tradotti in automatico al salvataggio"}</span>
      <button onClick={start} disabled={s.running} className="ml-auto flex items-center gap-2 rounded-full border-2 border-black px-4 py-1.5 font-semibold disabled:opacity-50" data-testid="tr-prewarm-button">
        {s.running && <Loader2 className="h-4 w-4 animate-spin" />}Aggiorna tutto
      </button>
    </div>
  );
};
